import _ from 'lodash';
import * as moment from 'moment';
import { isValid } from 'date-fns';
import * as yup from 'yup';
import { dependsOnModelRegex, dependsOnValuesRegex } from './constants';
import numeral from 'numeral';
import { olOrderColumns, plOrderColumns, zsOrderColumns, wrOrderColumns } from './column-definitions';
import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

import dayjs from 'dayjs';

export const validationError = errors => {
  let errorMessage = '';
  _.map(errors, obj => {
    _.map(obj, obj2 => {
      errorMessage += `${obj2.message}\n`;
    });
  });

  return errorMessage;
};

export const validateValues = (initErrors, value, type, maxLength, name) => {
  let errors = initErrors;
  if (type === 'string') {
    if (validateString(value, maxLength)) {
      if (!errors.includes(name)) {
        errors = [...errors, name];
      }
    } else {
      errors = errors.filter(item => item !== name);
    }
  } else if (type === 'integer') {
    if (validatePositiveInteger(value)) {
      if (!errors.includes(name)) {
        errors = [...errors, name];
      }
    } else {
      errors = errors.filter(item => item !== name);
    }
  } else if (type === 'float') {
    if (validatePositiveFloat(value)) {
      if (!errors.includes(name)) {
        errors = [...errors, name];
      }
    } else {
      errors = errors.filter(item => item !== name);
    }
  } else if (type === 'date') {
    if (!isValid(value)) {
      if (!errors.includes(name)) {
        errors = [...errors, name];
      }
    } else {
      errors = errors.filter(item => item !== name);
    }
  }

  return errors;
};

export const validateString = (string, maxLength) => {
  if (!_.isNull(string)) {
    if (string.length > maxLength) {
      return true;
    }
  }

  return false;
};

export const validatePositiveInteger = number => {
  if (!isPositiveInteger(number) || isNaN(number)) {
    return true;
  }

  return false;
};

export const validatePositiveFloat = number => {
  if (!isPositiveFloat(number) || isNaN(number)) {
    return true;
  }

  return false;
};

export const validatePhoneNumber = number => {
  if (true) {
    return true;
  }

  return false;
};

function isPositiveInteger(value) {
  // eslint-disable-next-line prefer-named-capture-group
  return (/^(\s*|\d+)$/).test(value);
}

function isPositiveFloat(value) {
  // eslint-disable-next-line prefer-named-capture-group
  return (/^(((?!00)\d*)(\.\d+)?){1}$/gm).test(value);
}

export function isInteger(value) {
  return (/^\d+$/).test(value);
}

export const formatDateTime = (date, withoutSeconds = false) => {
  if (date) {
    if (date instanceof Date) {
      if (isNaN(date)) {
        return null;
      }
      const dateFormatted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      const split = dateFormatted.toISOString().split('T');

      return withoutSeconds
        ? `${split[0]} ${split[1].substring(0, 5)}`
        : `${split[0]} ${split[1].substring(0, 8)}`;
    }

    const split = date.split('T');
    if (split.length > 1) {
      return withoutSeconds
        ? `${split[0]} ${split[1].substring(0, 5)}`
        : `${split[0]} ${split[1].substring(0, 8)}`;
    }

    return date;
  }

  return null;
};
export const formatDate = date => {
  if (date) {
    if (date instanceof Date) {
      if (isNaN(date)) {
        return null;
      }
      const dateFormatted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

      return dateFormatted.toISOString().split('T')[0];
    }

    return date.split('T')[0];
  }

  return null;

};

export const formatTime = date => {
  if (date) {
    if (date instanceof Date) {
      if (isNaN(date)) {
        return null;
      }
      const dateFormatted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      const split = dateFormatted.toISOString().split('T');

      return split[1].substring(0, 5);
    }

    return moment(date, 'HH:mm:ss');
  }

  return null;

};

export const validateRequiredFields = (initRequiredFields, value, name, required) => {
  if (!required) {
    return initRequiredFields;
  }
  let requiredFields = initRequiredFields;
  if (_.isNil(value) || _.isNull(value) || (typeof (value) === 'string' && _.isEmpty(value))) {
    if (!requiredFields.includes(name)) {
      requiredFields = [...requiredFields, name];
    }
  } else {
    requiredFields = requiredFields.filter(item => item !== name);
  }

  return requiredFields;
};

export const createYupSchema = (schema, config) => {
  const { name, validation_type, type, validations = [] } = config;

  // obsługa multichar zanim sprawdzimy validation_type
  if (['friends', 'siblings'].includes(name)) {
    let validator = yup.array();

    validations.forEach(validation => {
      const { params, type } = validation;

      if (type === 'minRows') {
        validator = validator.min(params[0], params[1]);
      }

      if (type === 'requiredRows') {
        validator = validator.test(
          'rows-valid',
          params[0],
          value => {
            if (!Array.isArray(value) || value.length === 0) {
              return false;
            }

            return value.every(row => row &&
              typeof row === 'object' &&
              Object.keys(row).length > 0 &&
              Object.values(row).every(v => v !== '' && v !== null && v !== undefined)
            );
          }
        );
      }
    });

    schema[name] = validator;

    return schema;
  }

  if (!yup[validation_type] && name != 'canoeing_activities') {
    return schema;
  }
  let validator = name != 'canoeing_activities' ? yup[validation_type]() : yup.string();
  validations.forEach(validation => {
    const { params, type } = validation;
    if (!validator[type]) {
      return;
    }
    if (type === 'oneOf') {
      if (_.isString(params[0][0]) && params[0][0].startsWith('ref:')) {
        params[0][0] = yup.ref(params[0][0].split(':')[1]);
      }
    } else if (type === 'matches') {
      params[0] = new RegExp(params[0]);
    }
    validator = validator[type](...params);
  });
  if (name.includes('participant_pesel')) {
    validator = yup
      .string()
      .test(
        'pesel-validation',
        'Nieprawidłowy numer PESEL',
        (value, context) => {
          if (context.parent.no_pesel === true) {
            return true;
          };
          if (!value) {
            return false;
          };
          const result = validatePesel(value);

          return result.valid; // sprawdza długość, sumę kontrolną itd.
        }
      )
      .test(
        'pesel-gender-match',
        'Podana płeć nie zgadza się z numerem PESEL',
        (value, context) => {
          if (context.parent.no_pesel === true) {
            return true;
          }
          if (!value) {
            return true;
          };

          const result = validatePesel(value);
          if (!result.valid) {
            return true;
          }; // błąd wyżej

          const genderDigit = parseInt(value[9], 10);
          if (
            context.parent.participant_gender?.includes('Chłopiec') &&
            genderDigit % 2 === 0
          ) {
            return false;
          }
          if (
            context.parent.participant_gender?.includes('Dziewczynka') &&
            genderDigit % 2 !== 0
          ) {
            return false;
          }

          return true;
        }
      )
      .test(
        'pesel-birthdate-match',
        'Data urodzenia nie zgadza się z numerem PESEL',
        (value, context) => {
          if (context.parent.no_pesel === true) {
            return true;
          }
          if (!value) {
            return true;
          }

          const result = validatePesel(value);
          if (!result.isDatowy) {
            return true; // brak daty → pomijamy
          }

          if (context.parent.birth_date) {
            return dayjs(context.parent.birth_date).format('YYYY-MM-DD') == result.birthDateISO;
          }

          return true;
        }
      )
      .when('no_pesel', {
        is: true,
        then: yup.string().nullable(),
        otherwise: yup
          .string()
          .required('Numer PESEL jest wymagany, jeśli nie zaznaczono opcji "brak PESEL"')
      });
  }


  if (type === 'multicharwithchoice') {
    validator = validator.required('To pole jest wymagane').test(
      'at-least-one-valid',
      'Proszę wybrać liczbę osób oraz uzupełnić dane',
      value => {
        if (value.length == 0) {
          return true;
        }
        if (!Array.isArray(value)) {
          return false;
        } // Sprawdzenie, czy to tablica

        return value.some(item => typeof item === 'object' && item !== null && Object.keys(item).length === 1);
      }
    );
  }

  if (name === 'participants_age_json') {
    const validatorMessage =
      'Proszę wybrać grupy wiekowe odpowiadające liczbie podanych uczestników';

    validator = validator.required('To pole jest wymagane').test(
      'at-least-one-valid',
      validatorMessage,
      value => {
        if (!Array.isArray(value)) {
          return false;
        }

        if (value.length === 0) {
          return true;
        }

        return value.every(
          item => item !== null &&
            typeof item === 'object' &&
            Object.keys(item).length === 2 &&
            Object.values(item).every(val => {
              if (val === '' || val === null || val === undefined) {
                return false;
              }

              return Number.isFinite(Number(val));
            })
        );
      }
    );
  }

  if (type === 'phonenumber' && name != 'guardian_additional_phone') {

    validator = validator
      .required('To pole jest wymagane')
      .test('phone-valid', 'Nieprawidłowy numer telefonu', value => {
        if (!value) {
          return false;
        };

        // Normalizacja – zapewnij znak plus
        const normalized = value.startsWith('+') ? value : `+${value}`;

        // Parsujemy numer
        const phone = parsePhoneNumberFromString(normalized);

        // Jeśli nie udało się sparsować — niepoprawny
        if (!phone) {
          return false;
        };

        const isValid = isValidPhoneNumber(normalized, phone.country);

        // Walidacja dla Polski: tylko 9 cyfr po kierunkowym
        const digits = normalized.replace(/\D/g, '');
        const dialCode = phone.countryCallingCode || '';
        const localPart = digits.slice(dialCode.length);
        const isPoland = phone.country === 'PL';
        const hasNineDigits = localPart.length === 9;

        return isValid && (!isPoland || hasNineDigits);
      });
  }

  schema[name] = validator;

  return schema;
};


/**
 * @param {String} dependsOn model-identifier string, eg season-z_21
 * @returns {[String, null]} exported identifier from dependsOn
 */
export const constructIdentifier = dependsOn => {
  const model = getDependsOnModel(dependsOn.replace('\n', '').split(' '));
  if (!_.isEmpty(model)) {
    return model[0].split('-')[1].replace(/\s/g, '');
  }

  return null;
};


/**
 * @param {String} strValue some string value
 * @param {String} regexPattern some regex pattern to test
 * @returns {String} boolean
 */
export const regexCustomValidations = (strValue, regexPattern) => {
  const regObj = new RegExp(regexPattern);

  return regObj.test(strValue);
};


/**
 * @param {String} dependsOn some string from json form schema
 * @returns {Array} empty array or first argument as model
 */
export const getDependsOnModel = dependsOn => _.filter(dependsOn, obj => obj.match(dependsOnModelRegex));


/**
 * Get all dependsOn values
 * @param {String} dependsOn some string from json form schema
 * @returns {Array} empty array or array of dependant values
 */
export const getDependsOnValues = dependsOn => {
  if (!_.isNil(dependsOn)) {
    return _.filter(dependsOn.trim().replaceAll('\n', '')
      .split(' '), obj => obj.replaceAll('\n', '').match(dependsOnValuesRegex));
  }

  return [];
};


/**
 * Get first dependsOn value
 * @param {String} dependsOn some string from json form schema
 * @returns {Array} empty array or array of dependant values
 */
export const getDependsOnValue = dependsOn => {
  if (!_.isNil(dependsOn)) {
    const values = _.filter(dependsOn.trim().replace('\n', '')
      .split(' '), obj => obj.match(dependsOnValuesRegex));
    if (!_.isEmpty(values)) {
      return values[0];
    }
  }

  return '';
};


/**
 * @param {String} dependsOn some string from json form schema
 * @param {[String, null]} rootFieldName root field name or null
 * @param {Object} formikValues formik values object
 * @param {Object} urlParams obiekt z parametrami z urla
 * @param {number | null} formVersion wersja formularza
 * @param {boolean} boskieWakacje czy formularz jest boskimi wakacjami
 * @returns {String} params
 */
export const constructDependsOnParams = (dependsOn, rootFieldName, formikValues, urlParams, formVersion, boskieWakacje) => {
  if (!_.isNil(formikValues[rootFieldName]) && (!_.isEmpty(formikValues[rootFieldName]) || _.isBoolean(formikValues[rootFieldName]))) {
    const values = getDependsOnValues(dependsOn);
    let params = `${rootFieldName}=${formikValues[rootFieldName]}&`;
    params += `root_name=${rootFieldName}&`;
    _.forEach(values, fieldName => {
      params += `${fieldName}=${formikValues[fieldName]}&`;
    });
    _.map(urlParams, (v, k) => {
      if (['resort', 'camp', 'event'].includes(k)) {
        params += `${k}=${v}&`;
      }
    });
    if (formVersion) {
      params += `form_version=${formVersion}&`;
    }
    if (boskieWakacje) {
      params += `boskie_wakacje=${boskieWakacje}`;
    }

    return params;
  }

  return null;
};


/**
 * @param {String} showOn show_on values from json form schema
 * @param {Object} formikValues formik values object
 * @param {Object} field showOn field object
 * @param {String} showOnCondition condition on show on - OR/AND
 * @returns {Boolean} can show
 */
export const handleShowOn = (showOn, formikValues, field, showOnCondition = 'OR') => {
  if (_.isNil(showOn) || _.isEmpty(showOn)) {
    return true;
  }
  if (showOnCondition == 'OR') {
    const args = showOn.trim().split(' ');
    const result = [];

    for (const arg of args) {
      const currentArg = arg.split('-');
      currentArg[0] = currentArg[0].replace('\n', '');
      if (currentArg.length > 1) {
        if (currentArg[1] === 'exists') {
          result.push(!_.isEmpty(formikValues[currentArg[0]]));
        } else if (currentArg[1] === 'false') {
          result.push(!formikValues[currentArg[0]]);
        } else if (currentArg[1] === 'true') {
          result.push(formikValues[currentArg[0]]);
        } else if (currentArg[1].includes('option_')) {
          if (typeof field.options[0] === 'object') {
            result.push(_.findIndex(field.options, obj => obj.id === formikValues[currentArg[0]]) == currentArg[1].slice(-1));
          }
          result.push(field.options.indexOf(formikValues[currentArg[0]]) == currentArg[1].slice(-1));
        } else if (currentArg[1].includes('choice_')) {
          result.push(formikValues[currentArg[0]] == currentArg[1].slice(-1));
        } else if (currentArg[1] === 'hasvalue') {
          const field = formikValues[currentArg[0]];
          // TODO tylko dla multicharwithchoice zrobione
          if (!field || field.length == 0) {
            result.push(false);
          } else {
            result.push(true);
          }
        }
      }
    }

    return result.includes(true);
  }
  // Kolejny warunek - AND, obecnie tylko dla pola zakwaterowania w wyjazdach rodzinnych
  // Zakładamy że będzie to Array z conajmniej 1 obiektem
  const args = showOn.trim().split(' ');
  const result = [];
  for (const arg of args) {
    const currentArg = arg.split('-');
    currentArg[0] = currentArg[0].replace('\n', '');
    if (currentArg[1] === 'hasvalue') {
      const formikField = formikValues[currentArg[0]];
      if (!formikField || formikField.length == 0) {
        result.push(false);
      }
    }
  }
  if (result.length == 0) {
    return true;
  }

  return false;

};


/**
 * @param {Integer} int some number between 0 and 1t
 * @returns {String} percent representation of given number
 */
export const numberToPercent = int => `${int * 100}%`;

/**
 * Wyciąga czytelny komunikat błędu z odpowiedzi DRF, np.
 * {"non_field_errors": ["..."]} lub {"date_from": ["..."]} lub ["..."].
 * @param {*} payload payload zwrócony przez mutate() przy błędzie (error: true)
 * @returns {String} czytelny komunikat błędu
 */
export const extractApiErrorMessage = payload => {
  if (!payload) {
    return 'Sprawdź poprawność wprowadzonych danych.';
  }
  if (typeof payload === 'string') {
    return payload;
  }
  if (Array.isArray(payload)) {
    return _.flattenDeep(payload).join(' ');
  }
  if (typeof payload === 'object') {
    return _.flattenDeep(Object.values(payload)).join(' ');
  }

  return 'Sprawdź poprawność wprowadzonych danych.';
};


/**
 * @param {String} params params as string
 * @returns {Array} array of params
 */
export const setEmptyChoicesFunction = params => params.trim().split(',');

/**
 * @param {String} params params as string
 * @returns {Array} array of params
 */
export const setRequiredFieldsFunction = params => params.trim().split(',');


/**
 * @param {String} params params as string
 * @returns {Array} array of params
 */
export const setBigFamilyCardFunction = params => params.trim().split(',');


/**
 * @param {Object} dynamicFunction function name
 * @param {Object} formik formik object
 * @param {Object} field form field object
 * @param {Any} val new field value
 * @returns {Array} array of params
 */
export const handleDynamicFunction = (dynamicFunction, formik, field, val) => {
  if (dynamicFunction.functionName === 'setEmptyChoicesFunction') {
    const newObjects = {};
    _.forEach(dynamicFunction.data, item => {
      newObjects[item] = '';
    });
    newObjects[field.name] = val;
    formik.setValues({ ...formik.values, ...newObjects });

    return { callback: null };
  } else if (dynamicFunction.functionName === 'setRequiredFieldsFunction') {
    if (field.name != 'discount') {
      formik.setFieldValue(field.name, val);
    }
    if (dynamicFunction.data[0].includes('true') || dynamicFunction.data[0].includes('false')) {
      return { callback: 'yupRequiredFieldsCallback', data: val };
    }

    return { callback: 'yupRequiredFieldsCallback', data: dynamicFunction.data };
  } else if (dynamicFunction.functionName === 'setBigFamilyCardFunction') {
    formik.setFieldValue(field.name, val);
    if (dynamicFunction.data.includes('true') || dynamicFunction.data.includes('false')) {
      return { callback: 'bigFamilyCardCallback', data: val };
    }

    return { callback: 'bigFamilyCardCallback', data: dynamicFunction.data };
  } else if (dynamicFunction.functionName === 'historicDataByPeselFunction') {
    return { callback: 'historicDataByPeselCallback', data: val };
  } else if (dynamicFunction.functionName === 'checkActivitiesFunction') {
    return { callback: 'checkActivitiesCallback', data: val };
  } else if (dynamicFunction.functionName === 'setDateToFunction') {
    return { callback: 'setDateToCallback', data: val };
  }
};

/**
 * @param {String} option option as string
 * @returns {Array} array of options
 */
export const getOptionIndex = option => option.split('-')[1].split('_')[1];

export const fNumber = number => numeral(number).format();

/**
 * @param {Date} date date object
 * @param {Integer} days days to add
 * @returns {Date} formatted date object
 */
export const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);

  return result;
};

/**
 * @param {String} module module identifier
 * @param {Function} method handleDetails function
 * @param {Function} handleAccomodationCheck instantly change to accomodated
 * @param {Function} handleConfirmStatus confirm state
 * @returns {Array} columns array
 */
export const getOrderColumns = (module, method, handleAccomodationCheck, handleConfirmStatus) => {
  if (!module) {
    return olOrderColumns();
  }
  if (module == 'obozy') {
    return olOrderColumns(method, handleAccomodationCheck, handleConfirmStatus);
  } else if (module == 'polkolonie') {
    return plOrderColumns(method, handleAccomodationCheck, handleConfirmStatus);
  } else if (module == 'zielone_szkoly') {
    return zsOrderColumns(method);
  } else if (module == 'wyjazdy_rodzinne') {
    return wrOrderColumns(method);
  }
};


/**
 * @param {String} date1 first string date
 * @param {String} date2 second string date
 * @returns {Integer} days difference int
 */
export const daysDifference = (date1, date2) => {
  try {
    const date1ToDateObject = new Date(date1);
    const date2ToDateObject = new Date(date2);
    const difference = date1ToDateObject.getTime() - date2ToDateObject.getTime();
    const totalDays = Math.ceil(difference / (1000 * 3600 * 24));
    if (totalDays > 1000) {
      return 0;
    }

    return totalDays;
  } catch (error) {
    return 0;
  }
};

export const calculateAge = (dateFrom, onlyAge = false, dateTo = null) => {
  let today = new Date();
  if (dateTo) {
    today = new Date(dateTo);
  }
  const birthDate = new Date(dateFrom);

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();
  const dayDifference = today.getDate() - birthDate.getDate();

  // Jeśli miesiąc lub dzień bieżącego roku jest wcześniejszy niż data urodzenia, odejmij 1 rok.
  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    age--;
  }
  if (onlyAge) {
    return age;
  }

  return `${age} ${age === 1 ? 'rok' : (age > 1 && age < 5 ? 'lata' : 'lat')}`;
};

export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }

  return color;
};

export const extractTimeFromISOString = dateString => {
  if (!dateString) {
    return '';
  }
  const date = new Date(dateString);
  // Format the time into HH:MM:SS
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};

export const isIntegerString = str => (/^\d+$/).test(str);

export const isSingleEmptyObjectArray = variable => Array.isArray(variable) &&
  variable.length === 1 &&
  typeof variable[0] === 'object' &&
  variable[0] !== null &&
  Object.keys(variable[0]).length === 0;


export function getDateRange(startDate, endDate) {
  const dates = [];
  const current = new Date(startDate);

  // eslint-disable-next-line no-unmodified-loop-condition
  while (current <= endDate) {
    // Dodaj kopię daty w formacie YYYY-MM-DD
    dates.push(current.toISOString().split('T')[0]);

    // Przejdź do następnego dnia
    current.setDate(current.getDate() + 1);
  }

  return dates;
}

/**
 * Walidacja PESEL + rozpoznanie "datowy" / "bezdatowy".
 * Zwraca obiekt:
 * {
 *   valid: boolean,            // czy PESEL przeszedł wszystkie testy (format + checksum)
 *   reason: string|null,       // przyczyna błędu gdy valid === false
 *   isDatowy: boolean,         // czy zawiera poprawną datę
 *   birthDate: Date|null,      // jeśli datowy -> obiekt Date (UTC, start dnia)
 *   birthDateISO: string|null, // jeśli datowy -> ISO yyyy-mm-dd
 * }
 */

export const validatePesel = peselInput => {
  let pesel = peselInput;

  if (typeof pesel !== 'string') {
    pesel = String(peselInput);
  }
  const out = { valid: false, reason: null, isDatowy: false, birthDate: null, birthDateISO: null };

  // usuń spacje, myślniki itp.
  const normalized = pesel.replace(/\s|-/g, '');
  const peselRegex = (/^\d{11}$/);

  if (!peselRegex.test(normalized)) {
    out.reason = 'PESEL musi składać się z 11 cyfr';

    return out;
  }

  const digits = normalized.split('').map(d => parseInt(d, 10));

  // suma kontrolna (wagi: 1 3 7 9 1 3 7 9 1 3)
  const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  const sum = weights.reduce((acc, w, i) => acc + w * digits[i], 0);
  const checksum = (10 - (sum % 10)) % 10;
  if (checksum !== digits[10]) {
    out.reason = 'Nieprawidłowa suma kontrolna';

    return out;
  }

  // wydobądź datę
  const yy = parseInt(normalized.slice(0, 2), 10);
  let mm = parseInt(normalized.slice(2, 4), 10);
  const dd = parseInt(normalized.slice(4, 6), 10);

  // ustalenie stulecia na podstawie mm
  let yearFull = null;
  if (mm >= 1 && mm <= 12) {
    yearFull = 1900 + yy;
  } else if (mm >= 21 && mm <= 32) {
    yearFull = 2000 + yy;
    mm -= 20;
  } else if (mm >= 41 && mm <= 52) {
    yearFull = 2100 + yy;
    mm -= 40;
  } else if (mm >= 61 && mm <= 72) {
    yearFull = 2200 + yy;
    mm -= 60;
  } else if (mm >= 81 && mm <= 92) {
    yearFull = 1800 + yy;
    mm -= 80;
  } else {
    // niepoprawny miesiąc -> nie datowy
    out.valid = true; // suma ok => numer formalnie poprawny, ale bez daty
    out.isDatowy = false;
    out.reason = 'PESEL nie zawiera poprawnego zakodowanego miesiąca (brak daty)';

    return out;
  }

  // sprawdź czy dzień/miesiąc tworzą poprawną datę (uwzględnia luty/przestępne)
  // utwórz datę w UTC (unikamy przesunięć strefowych)
  const date = new Date(Date.UTC(yearFull, mm - 1, dd, 0, 0, 0));
  const validDate =
    date.getUTCFullYear() === yearFull &&
    date.getUTCMonth() === (mm - 1) &&
    date.getUTCDate() === dd;

  if (!validDate) {
    out.valid = true; // suma ok
    out.isDatowy = false;
    out.reason = 'PESEL ma nieprawidłowy dzień/miesiąc (data nie istnieje)';

    return out;
  }

  // wszystko OK: suma kontrolna i data poprawna
  out.valid = true;
  out.isDatowy = true;
  out.birthDate = date;
  out.birthDateISO = dayjs(date).format('YYYY-MM-DD'); // yyyy-mm-dd
  out.reason = null;

  return out;
};


export const extractYearFromOrderIdentifier = identifier => {
  // eslint-disable-next-line prefer-named-capture-group
  const match = identifier?.match(/\/[a-zA-Z]+(\d{4})\//);

  return match ? Number(match[1]) : null;
};
